
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.4816 4.03386L4.0346 11.4808C3.64408 11.8714 3.64408 12.5045 4.0346 12.8951L11.1057 19.9661C11.4962 20.3567 12.1294 20.3567 12.5199 19.9661L19.9669 12.5191C20.1767 12.3093 20.2825 12.0171 20.2557 11.7215L19.6664 5.23969C19.6227 4.75894 19.2418 4.37804 18.761 4.33433L12.2792 3.74508C11.9837 3.71821 11.6914 3.82401 11.4816 4.03386Z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.7012 8.29851C16.0918 8.68903 16.0918 9.3222 15.7012 9.71272C15.3107 10.1032 14.6776 10.1032 14.287 9.71272C13.8965 9.3222 13.8965 8.68903 14.287 8.29851C14.6776 7.90798 15.3107 7.90798 15.7012 8.29851Z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    